import { partnerApi, StoreKey } from '../../configs/api';
import { getAppHeader, getAuthHeaders, RegexConfig } from '../../configs/config';
import { ROUTE } from '../../routes';
import { ButtonTypeTokens, CalendarStateToken, InputStateToken, } from '@voltmoney/schema';
import moment from 'moment/moment';
import { heightMap } from '../../configs/height';
import sharedPropsService from '../../SharedPropsService';
import { isMobile } from "../../configs/utils";
const _isMobile = isMobile();
const tableSearchString = '';
// export const mockDATA = MockDataJson;
const searchIndex = [];
let pan = '';
let fullName = '';
let phoneNumber = '';
let email = '';
let dob = '';
let counter = 0;
export const TestAction = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    // console.warn("**** Test Action Triggered ****", action);
};
export const onClosePopup = async (action, _datastore, { hidePopup, asyncStorage, navigate }) => {
    console.warn('**** onClosePopup Action Triggered ****', action);
    const currentActiveTabIndex = action?.payload.currentActiveTabIndex;
    const currentPage = action?.payload.currentPage;
    const searchContext = action?.payload?.searchContext;
    await asyncStorage.set('GO_TO_REGISTER_LEADS', 'false');
    await asyncStorage.set('u_data', null);
    if (currentActiveTabIndex !== undefined && currentPage !== undefined) {
        await navigate(ROUTE.PARTNER_LEAD, { currentPendingCustomerActiveTabIndex: currentActiveTabIndex, currentPage, searchContext });
    }
    else
        await hidePopup();
};
export const onChangeInput = async (action, _datastore, utilities) => {
    const { setDatastore } = utilities;
    console.warn('**** onChangePan Action Triggered ****', action);
    let isDobComplete = false;
    const panRegex = new RegExp(RegexConfig.PAN);
    let isPanValid = panRegex.test(pan);
    if (action.payload.widgetId === 'panInput') {
        pan = action.payload.value;
        isPanValid = panRegex.test(pan);
        if (isPanValid) {
            await fetchNameFromPAN(pan, utilities);
        }
    }
    if (action.payload.widgetId === 'fullName') {
        fullName = action.payload.value;
    }
    if (action.payload.widgetId === 'calendarPicker') {
        if (action.payload.value && action.payload.value.length === 10) {
            isDobComplete = true;
        }
        dob = `${moment(action.payload.value, 'DD-MM-yyyy').valueOf()}`;
    }
    if (action.payload.widgetId === 'mobileNumberInput') {
        phoneNumber = action.payload.value;
    }
    if (action.payload.widgetId === 'emailInput') {
        email = action.payload.value;
    }
    const currentDate = Date.now();
    const minDate = currentDate - 100 * 31557600000;
    const maxDate = currentDate - 18 * 31557600000;
    const isDobValid = parseInt(dob) >= minDate && parseInt(dob) <= maxDate;
    if (isDobValid) {
        // const dobInddMMyyyy = moment.unix(Number(dob) / 1000).format("DD-MM-yyyy");
        // await SharedPropsService.setUserDob(dobInddMMyyyy);
        await setDatastore(ROUTE.REGISTER_LEADS, 'calendarPicker', {
            state: CalendarStateToken.DEFAULT,
        });
    }
    else if (isDobComplete) {
        //If dob is not valid but is complete in terms of format dd-MM-yyyy then throw error
        await setDatastore(ROUTE.REGISTER_LEADS, 'calendarPicker', {
            state: CalendarStateToken.ERROR,
        });
    }
    console.log('panInput: ', pan);
    console.log('fullName: ', fullName);
    console.log('calendarPicker: ', dob);
    console.log('mobileNumberInput: ', phoneNumber);
    console.log('emailInput: ', email);
    const emailRegex = new RegExp(RegexConfig.NEW_EMAIL);
    const isEmailValid = emailRegex.test(email);
    const phoneNumberRegex = new RegExp(RegexConfig.MOBILE);
    const isPhoneNumberValid = phoneNumberRegex.test(phoneNumber);
    if (email.length > 0 && !emailRegex.test(email)) {
        await setDatastore(ROUTE.REGISTER_LEADS, "emailInput", {
            state: InputStateToken.ERROR,
            caption: { error: "Please enter a valid email" }
        });
    }
    else {
        await setDatastore(ROUTE.REGISTER_LEADS, "emailInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: "" }
        });
    }
    if (pan.length > 0 && !panRegex.test(pan)) {
        await setDatastore(ROUTE.REGISTER_LEADS, "panInput", {
            state: InputStateToken.ERROR,
            caption: { error: "Please enter a valid PAN" }
        });
    }
    else {
        await setDatastore(ROUTE.REGISTER_LEADS, "panInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: "" }
        });
    }
    if (isPanValid &&
        isEmailValid &&
        fullName &&
        isDobValid &&
        isPhoneNumberValid) {
        await sharedPropsService.setRegisterLeadButtonActive(false);
        await setDatastore(ROUTE.REGISTER_LEADS, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    else {
        await sharedPropsService.setRegisterLeadButtonActive(true);
        await setDatastore(ROUTE.REGISTER_LEADS, 'continue', {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
};
export const onTriggerCTA = async (action, _datastore, { hidePopup, asyncStorage, setDatastore, navigate, showPopup, network }) => {
    console.warn('**** onTriggerCTA Action Triggered ****', action);
    const partnerContextString = await asyncStorage.get(StoreKey.userContext);
    const partnerUserContext = JSON.parse(partnerContextString);
    const partnerAccountId = partnerUserContext?.linkedPartnerAccounts[0]?.accountId;
    const platformCode = partnerUserContext?.linkedPlatformAccounts[0]?.platformCode;
    await setDatastore(ROUTE.REGISTER_LEADS, 'continue', {
        loading: true,
    });
    const header = await getAppHeader();
    await network
        .post(`${partnerApi.customer}${partnerAccountId}/customer`, {
        dob: dob,
        email: email,
        panNumber: pan,
        phoneNumber: `+91${phoneNumber}`,
    }, {
        headers: header
    }, async () => {
        await setDatastore(ROUTE.REGISTER_LEADS, 'continue', {
            type: ButtonTypeTokens.LargeOutline,
        });
    }, {
        width: _isMobile ? '100%' : heightMap[ROUTE.VOLT_APP],
    })
        .then(async (res) => {
        console.log('res 123: ', res);
        if (res && res?.status === 200) {
            // clearing cache to fresh fetch
            const isPrevRouteLeads = action?.payload.isPrevRouteLeads;
            console.log("Lead registered successfully: ", isPrevRouteLeads);
            await hidePopup();
            dob = '';
            await setDatastore(ROUTE.REGISTER_LEADS, "calendarPicker", {
                year: { title: "Year *", value: '', placeholder: "YYYY" },
                month: { title: "Month *", value: '', placeholder: "MM" },
                date: { title: "Date *", value: '', placeholder: "DD" },
                state: CalendarStateToken.DEFAULT,
            });
            await navigate(ROUTE.REGISTER_LEADS_SUCCESS, {
                updatedApplicationObj: res.data.updatedApplicationObj,
                stepResponseObject: res.data.stepResponseObject,
                isPrevRouteLeads: isPrevRouteLeads
            });
        }
        await asyncStorage.set('u_data', null);
    });
    await setDatastore(ROUTE.REGISTER_LEADS, 'continue', {
        loading: false,
    });
};
export const onDisableSubmit = async (action, _datastore, { hidePopup, setDatastore }) => {
    console.warn('**** onDisableSubmit Action Triggered ****', action);
    await setDatastore(ROUTE.REGISTER_LEADS, 'continue', {
        type: ButtonTypeTokens.LargeOutline,
    });
};
export const failedVerifiction = async (action, _datastore, { hidePopup, setDatastore }) => {
    console.warn('**** failedVerifiction Action Triggered ****', action);
    hidePopup();
};
export const onEnableSubmit = async (action, _datastore, { hidePopup, setDatastore }) => {
    console.warn('**** onDisableSubmit Action Triggered ****', action);
    await setDatastore(ROUTE.REGISTER_LEADS, 'continue', {
        type: ButtonTypeTokens.LargeFilled,
    });
};
export const onSendOTPAction = async (action, _datastore, { network, setDatastore, instrumentTrack }) => {
    const resendOTP = action?.payload?.resendOTP ? action?.payload?.resendOTP : false;
    const userPhoneNumber = action?.payload?.phoneNumber;
    const pNumber = userPhoneNumber.includes("+91") ? userPhoneNumber : `+91${userPhoneNumber}`;
    const userName = action?.payload?.name;
    await instrumentTrack('OTP_REQUESTED_TO_REGISTER_CUSTOMER', {
        name: userName,
        phone: pNumber
    });
    if (!resendOTP) {
        await setDatastore(ROUTE.REGISTER_LEADS, "partnerRegisterLeads", {
            sendOTPLoader: true,
            showErrorCard: false,
            showOTPModal: false,
            otpState: InputStateToken.DEFAULT
        });
    }
    else {
        await setDatastore(ROUTE.REGISTER_LEADS, "partnerRegisterLeads", {
            otpState: InputStateToken.DEFAULT
        });
    }
    const requestUrl = `${partnerApi.registerLeadsTriggerOTP}${pNumber}`;
    const response = await network.get(`${requestUrl}`, {
        headers: await getAuthHeaders(),
        handleFromMF: true
    });
    if (response?.status === 200) {
        await setDatastore(ROUTE.REGISTER_LEADS, "partnerRegisterLeads", {
            showOTPModal: true,
            showErrorCard: false,
            counter: counter++,
        });
    }
    else {
        const errorMessage = response?.response?.data?.message?.toString().trim();
        const errorCode = response?.response?.data?.voltErrorCode?.toString().trim();
        await setDatastore(ROUTE.REGISTER_LEADS, "partnerRegisterLeads", {
            showErrorCard: true,
            errorMessage: `${errorMessage}`,
            errorCode: `${errorCode}`,
            counter: counter++
        });
    }
};
export const fetchNameFromPAN = async (panNumber, standardUtilities) => {
    await standardUtilities.setDatastore(ROUTE.REGISTER_LEADS, 'panInput', {
        loading: true,
    });
    await standardUtilities.network
        .post(`${partnerApi.panValidate}`, {
        panNumber: pan,
    }, {
        headers: await getAppHeader(),
    }, null, {
        width: _isMobile ? '100%' : heightMap[ROUTE.VOLT_APP],
    })
        .then(async (res) => {
        console.log('res network layer: ', res);
        if (res && res.data) {
            fullName = res.data.fullName;
            await standardUtilities.setDatastore(ROUTE.REGISTER_LEADS, 'fullName', {
                value: res.data.fullName,
            });
        }
    });
    await standardUtilities.setDatastore(ROUTE.REGISTER_LEADS, 'panInput', {
        loading: false,
    });
};
export const onLoad = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    console.warn('**** onLoad Action Triggered ****', action);
    pan = '';
    fullName = '';
    phoneNumber = '';
    email = '';
    dob = '';
    await setDatastore(ROUTE.REGISTER_LEADS, "fullName", {
        value: ''
    });
    await setDatastore(ROUTE.REGISTER_LEADS, "panInput", {
        value: ''
    });
    await setDatastore(ROUTE.REGISTER_LEADS, "emailInput", {
        value: ''
    });
    await setDatastore(ROUTE.REGISTER_LEADS, "calendarPicker", {
        regex: RegexConfig.MOBILE,
        year: { title: "Year *", value: "", placeholder: "YYYY" },
        month: { title: "Month *", value: "", placeholder: "MM" },
        date: { title: "Date *", value: "", placeholder: "DD" },
    });
    await sharedPropsService.setRegisterLeadButtonActive(false);
};
export const verifyOTPAction = async (action, _datastore, { network, asyncStorage, navigateWithClear, setDatastore }) => {
    const userName = action?.payload?.name;
    const otp = action?.payload?.otp;
    const phoneNumber = action?.payload?.phoneNumber;
    const pNumber = phoneNumber.includes("+91") ? phoneNumber : `+91${phoneNumber}`;
    const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
    const response = await network.post(`${partnerApi.verifyLeadsOTPAndCreateAccount}${partnerAccountId}/verifyAndCreateBorrower`, {
        name: userName.toString(),
        otp: otp?.toString(),
        phoneNumber: pNumber?.toString()
    }, {
        headers: await getAppHeader(),
        handleFromMF: true
    });
    const applicationId = response?.data?.linkedApplications[0]?.applicationId;
    const borrowerAccountId = response?.data?.linkedApplications[0]?.accountId;
    if (response?.status === 200) {
        navigateWithClear(ROUTE.REGISTER_LEADS_SUCCESS, {
            applicationId: applicationId,
            borrowerAccountId: borrowerAccountId,
            user: response?.data?.user,
            name: userName
        });
    }
    else {
        const errorResponse = response?.response?.data;
        await setDatastore(ROUTE.REGISTER_LEADS, "partnerRegisterLeads", {
            otpState: errorResponse?.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP" ? InputStateToken.DISABLED : InputStateToken.ERROR,
            sendOTPLoader: false,
            errorMessage: errorResponse?.message,
            counter: Math.random()
        });
    }
};
export const closeOtpModalAction = async (action, _datastore, { hidePopup, setDatastore }) => {
    await setDatastore(ROUTE.REGISTER_LEADS, "partnerRegisterLeads", {
        sendOTPLoader: false
    });
};
